// @flow

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import LoginForm from 'components/organisms/LoginForm'
import { actions as accountActions } from 'redux/modules/account'
import { setUIState } from 'redux/modules/ui'
import Redirect from 'components/atoms/Redirect'
import AccountUseCase, {
  type AccountUseCaseType,
} from 'usecases/AccountUseCase'
import withRest from 'frontend_core/dist/api/rest/withRest'

type Props = {
  accountUseCase: AccountUseCaseType,
  account: {},
  ui: {},
}

class Container extends React.Component<Props> {
  render() {
    const { accountUseCase, account, ui } = this.props
    return account.doneUrl ? (
      <Redirect to={account.doneUrl} />
    ) : (
      <LoginForm
        account={account}
        ui={ui}
        onSubmit={accountUseCase.login}
        onChange={accountUseCase.inputLoginForm}
      />
    )
  }
}
function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    login: accountActions.login,
    setAccount: accountActions.setAccount,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  withRest(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(AccountUseCase(Container)),
  ),
)
